import PaymentModal, { REFUND  } from 'template/Modals/NewPayment';
import { alert } from 'util/alert';

//
// refund class
//
// NOTE: 'this' here is bind to a TabComponent (eg. DefaultTab) where unmodified students state is stored.
//
export default function refundClass ({ trData: student }) {
  const {
    user,
    studentState,
  } = this.props;

  let user_id = user.result.user_id;

  PaymentModal({ student, user_id, paymentType: REFUND })
    .then(({ success })=>{
      if (success) {
        this.props.student.fetchStudent('after refund was made', studentState);
      }
    }).catch((err)=>{
      console.error(err);
    });
}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/refund.js